/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_Invalid_AmountInputs */

const en_admin_users_credits_invalid_amount = /** @type {(inputs: Admin_Users_Credits_Invalid_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a positive amount`)
};

const zh_admin_users_credits_invalid_amount = /** @type {(inputs: Admin_Users_Credits_Invalid_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入正数`)
};

/**
* | output |
* | --- |
* | "Enter a positive amount" |
*
* @param {Admin_Users_Credits_Invalid_AmountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_invalid_amount = /** @type {((inputs?: Admin_Users_Credits_Invalid_AmountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_Invalid_AmountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_credits_invalid_amount(inputs)
	return zh_admin_users_credits_invalid_amount(inputs)
});
export { admin_users_credits_invalid_amount as "admin.users.credits_invalid_amount" }